import React, {useState, useRef} from 'react'
import styles from './styles.css'
import SendIcon from 'react-icons/lib/md/send'
import ImageIcon from 'react-icons/lib/md/image'
import useMutate from 'apollo-hooks/lib/useMutate'
import useClient from 'apollo-hooks/lib/useClient'
import useMessage from 'App/hooks/useMessage'
import useUserId from 'App/hooks/useUserId'
import sendMessage from './sendMessage'
import Loading from 'react-loading'

export default function Send(props) {
  const mutate = useMutate()
  const client = useClient()
  const showMessage = useMessage()
  const userId = useUserId()
  const input = useRef()
  const [loading, setLoading] = useState(false)

  const onClick = async () => {
    const text = props.text
    try {
      props.setText('')
      await sendMessage({mutate, userId, text, conversationId: props.conversationId})
    } catch (error) {
      props.setText(text)
      showMessage(error)
    }
  }

  const selectImage = async event => {
    setLoading(true)
    const image = event.target.files[0]
    if (image) {
      await sendMessage({client, mutate, userId, image, conversationId: props.conversationId})
    }
    input.current.value = ''
    setLoading(false)
  }

  return (
    <div className={styles.container}>
      {/* <div className={styles.icon}>
        <ImageIcon size={25} />
      </div> */}
      <input
        ref={input}
        type="file"
        name="image"
        style={{display: 'none'}}
        onChange={selectImage}
        accept="image/*"
      />
      <div className={styles.icon} onClick={() => input.current.click()}>
        {loading ? (
          <Loading type="spinningBubbles" color="#aaaaaa" height={25} width={25} />
        ) : (
          <ImageIcon size={25} />
        )}
      </div>
      <div className={props.text ? styles.icon : styles.disabled} onClick={onClick}>
        <SendIcon size={25} />
      </div>
    </div>
  )
}
